import { ItemKey } from '../item_key';
import { SupplierId } from '../supplier_id';

/// Items/products項目設定に必要な要素を設定
export class AnalyticsItem {
  // eslint-disable-next-line max-params
  constructor(
    /// productName：
    public _supplierId: SupplierId = new SupplierId(''),
    public _catalogItemCode: string = '',
    public _quantity: string = '',
    public _price: string = '',
    public _events: Array<string> = [''],
    /// evars：
    public _medicalMaterialType: string = '',
    public _substituteItemKey: ItemKey = new ItemKey(),
    public _viewAreaName: string = '',
    /// props:
    public _internalCampaignCode: string = ''
  ) {}

  /// productName：
  /// ・アスクル商品の場合、catalogItemCodeを設定
  /// ・サプライヤ商品の場合、supplierIdとcatalogItemCodeを連結
  getProductName(): string {
    if (this._supplierId.isAskul()) {
      return this._catalogItemCode;
    }
    return `${this._supplierId.rawValue()}${this._catalogItemCode}`;
  }

  /// productName(soloel):
  getProductNameForSoloel(): string {
    return `${this._supplierId.rawValue()}${this._catalogItemCode}`;
  }

  /// evars：
  /// 医療材料区分がない場合「none」を設定
  getMedicalMaterialType(): string {
    if (this._medicalMaterialType == null || this._medicalMaterialType === '') {
      return 'none';
    }
    return this._medicalMaterialType;
  }

  /// props:
  /// p20.サイト内キャンペーン
  getInternalCampaignCode(): string {
    return this._internalCampaignCode;
  }
}
